import React from 'react';
import {useNavigate} from 'react-router';

import {Spotlight, SpotlightActionData, spotlight} from '@mantine/spotlight';
import {Input} from '@mantine/core';


import {useSelectorWithRefresh} from '@/store/kysely_module';
import {IconNote, IconNotebook, IconSearch} from '@tabler/icons-react';

import '@mantine/spotlight/styles.css';
import {useIsMobile} from '@/utils/user_agent';
import {useCurrentWorkspaceId} from '@/store/modules/workspaces_module';
import {navigateToPathForReason} from '@/modules/navigation/navigation_module';

const defaultArray: any[] = [];

export const SearchBar = () => {
    const isMobile = useIsMobile();

    const [searchQuery, setSearchQuery] = React.useState('');
    const navigate = useNavigate();

    const [searchBarHasFocus, setSearchBarHasFocus] = React.useState(false);
    const workspaceId = useCurrentWorkspaceId();

    const [searchResults, refreshSearchResults, isLoading] = useSelectorWithRefresh('searchEverything', {query: searchQuery}, defaultArray, {workspace_id: null});
    const prevData = React.useRef(searchResults);

    React.useEffect(() => {
        if (!isLoading) {
            prevData.current = searchResults;
        }
    }, [isLoading]);

    const results = (isLoading ? prevData.current : searchResults) || [];

    if (results.length === 0) {
        // debugger;
    }

    const openSpotlight = () => {
        spotlight.open();

        if (searchQuery) {
            setSearchQuery('');
        } else {
            refreshSearchResults();
        }
    };

    const spotlightActions: SpotlightActionData[] = results.filter((result) => result).map((result) => ({
        id: result.id,
        leftSection: <IconNotebook size={16} />,
        // title: result.name,
        label: `${result.name}`,
        // description: result.description ?? undefined,
        // url: `/workspaces/${result.workspace_id}/projects/${result.id}`,
        onClick: () => {
            navigateToPathForReason(navigate, 'navigate_to_project_page_from_search_bar', `/workspaces/${result.workspace_id}/projects/${result.id}`);
        },
    }));

    return (
        <>
            {isMobile ? (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'flex-end',
                    }}
                >
                    <IconSearch
                        // style={{position: 'absolute', right: '-50px', transform: 'translate(-50%, -50%)'}}
                        size={22}
                        onClick={() => {
                            openSpotlight();
                        }}
                    />
                </div>
            ) : (
                <div style={{width: '300px', position: 'relative'}}>
                    <Input
                        leftSection={<IconSearch size={16} />}
                        style={{width: '100%'}}
                        readOnly
                        type="text"
                        // placeholder="Search"
                        // value={searchQuery}
                        // onChange={(e) => setSearchQuery(e.target.value)}
                        // onFocus={() => setSearchBarHasFocus(true)}
                        // onBlur={() => setSearchBarHasFocus(false)}
                        onClick={() => {
                            openSpotlight();
                        }}
                />
                </div>
            )}

            <Spotlight
                actions={spotlightActions}
                nothingFound="Nothing found..."
                // highlightQuery
                searchProps={{
                    leftSection: <IconSearch size={20} stroke={1.5} />,
                    placeholder: 'Search...',
                    onChange: (e) => setSearchQuery(e.target.value),
                }}
            />

            {/* {(searchBarHasFocus || searchQuery) && (
                <ul>
                    {results.map((result) => (
                        <li key={result.id}>
                            <a href={`/workspaces/${result.workspace_id}/projects/${result.id}`}>{result.name}</a>
                        </li>
                    ))}
                </ul>
            )} */}
        </>
    );
};
